module.exports = __webpack_public_path__ + "img/deliveryLocations.10603022.svg";